import { Navigate } from 'react-router';
import { useContext, type ReactElement } from 'react';
import { RootContext } from '@stores';

export default function Home(): ReactElement {
  const { user } = useContext(RootContext);
  const url = (typeof user?.tenantSettings?.index === 'string' && user?.tenantSettings.index.length > 0)
    ? user?.tenantSettings.index
    : '/login';

  return (<Navigate to={url} replace />);
}
